<template>
  <div>
    <px-view-header title="Categorias" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-grupo-list-header :on-click-refresh="onClickRefresh"
                          :on-change-filter="onChangeFilter" />
    <px-grupo-list :grupos="grupos"
                   :loading="loading"
                   :on-change-options="onChangeOptions"
                   :options-list="optionsList"
                   @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import GruposService from './grupos-service';
import GrupoList from './GrupoList.vue';
import GrupoListHeader from './GrupoListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Categorias' },
      ],
      grupos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'descricao',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemGrupos', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getGrupos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getGrupos();
    },
    onClickRefresh() {
      this.getGrupos();
    },
    onRemove(item) {
      this.loading = true;
      GruposService.remover(item.id)
        .then(() => {
          this.$toast('Grupo removido com sucesso', { color: 'success' });
          this.getGrupos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getGrupos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return GruposService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.grupos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxGrupoList: GrupoList,
    pxGrupoListHeader: GrupoListHeader,
  },
};

</script>
